module.exports = __webpack_public_path__ + "img/vacation-penguin.f1f52b9c.svg";